module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "terminal",
    staticClass: "terminal"
  }, [_vm._l((_vm.responses), function(item) {
    return _c('div', {
      staticClass: "terminal-line"
    }, [(item.type === 'command') ? _c('prompt', {
      attrs: {
        "active": false,
        "text": item.text,
        "directory": item.directory
      }
    }) : _c('response', {
      attrs: {
        "content": item.content,
        "type": item.type
      }
    })], 1)
  }), _vm._v(" "), _c('prompt', {
    attrs: {
      "active": true,
      "visible": _vm.promptActive,
      "directory": _vm.state.currentSub
    },
    on: {
      "emitCommand": _vm.saveCommand
    }
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2e69de93!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Terminal.vue
// module id = 290
// module chunks = 2